import { callApiToServer } from "../callApi";

export async function deleteCourseSessionTopic(authtoken, courseSessionTopicId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      "topic_id": courseSessionTopicId
    })
    let endUrl = `v1/auth/admin/delete-course-session-topic`;
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);
    console.log(responseData);
    return responseData;
  } catch (err) {
    throw err;
  }
}
